import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/order-create-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/OrderForm';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import OrderEnum from 'src/enumerables/order-enum';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import { IServiceType } from 'src/types/service-types';
import { routes } from '../../../../../../navigation';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import Router from '../../../../../../navigation/router';

export interface StateProps {
    orderTypeValue: string | number;
    valueType: SelectObject;
    statusItemValue: string | number;
    orderTypes: SelectObject[];
    inProgress: boolean;

    students: SelectObject[];
    serviceTypesOrder: Paginated<IServiceType>;
}

export interface DispatchProps {
    getStudentsAct: (params: QueryParams) => void;
    getOrderServiceTypes: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const OrderCreateScreen: React.FunctionComponent<Props> = (props) => {
    const [files, setFiles] = useState([]);
    const [orderDoc, setOrderDoc] = useState(null);
    useEffect(() => {
        props.getStudentsAct({
            page: 1,
            itemsPerPage: 9000,
        });

        props.getOrderServiceTypes({
            page: 1,
            itemsPerPage: 9000,
        });
        // eslint-disable-next-line
    }, [props.getStudentsAct, props.getOrderServiceTypes]);
    /*  const handleSub = (handleSubmit: (e: any) => void, e: any) => {

        if (!orderDoc) {
            toast.error('Need Order Doc!');
            return false;
        } else {
            handleSubmit(e);

        }
    };*/
    const typeEnumSubT = OrderEnum ? OrderEnum.getEnum('OrderSubtype') : {};
    const valuesOrderSubtype: SelectObject[] = getValFromEnum(typeEnumSubT);

    const AuthorizationSources = OrderEnum ? OrderEnum.getEnum('AuthorizationSource') : {};
    const valuesAuthorizationSources: SelectObject[] = getValFromEnum(AuthorizationSources);

    const AllocatedPeriod = OrderEnum ? OrderEnum.getEnum('AllocatedPeriod') : {};
    const valuesAllocatedPeriod: SelectObject[] = getValFromEnum(AllocatedPeriod);

    const OrderStatusValues = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
    const valuesOrderStatus: SelectObject[] = getValFromEnum(OrderStatusValues);

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderCaseType') : {};
    const orderCaseTypeValues: SelectObject[] = getValFromEnum(typeEnum);

    const ServiceTypeProvidersEnum = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const ServiceTypeProviders: SelectObject[] = getValFromEnum(ServiceTypeProvidersEnum);

    const referralEnum = OrderEnum ? OrderEnum.getEnum('ReferralSource') : {};
    const orderReferralSourceValues: SelectObject[] = getValFromEnum(referralEnum);

    const serviceTypesOrderValues: SelectObject[] = [];
    props.serviceTypesOrder.list.forEach((it: Partial<IServiceType>) => {
        const labelArr = [];
        if (it.title) {
            labelArr.push(it.title);
        }
        if (it.cpt) {
            labelArr.push(`CPT: [${it.cpt}]`);
        }
        const label = labelArr.join(', ');
        serviceTypesOrderValues.push({ value: it.id, label });
    });

    return (
        <RoleLayout>
            <Breadcrumbs
                noGenerate={true}
                items={[
                    { name: 'ORDERS', path: Router.generate(routes.ORDERS_LIST, { status: '' }) },
                    { name: `ADD NEW`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                {props.inProgress ? <Loader /> : null}
                <Form
                    orderDoc={orderDoc}
                    setOrderDoc={setOrderDoc}
                    removeOrderDoc={(id) => {
                        setOrderDoc(null);
                    }}
                    orderTypeValue={props.orderTypeValue}
                    valueType={props.valueType}
                    statusItemValue={props.statusItemValue}
                    OrderTypes={props.orderTypes}
                    valuesOrderSubtype={valuesOrderSubtype}
                    valuesOrderStatus={valuesOrderStatus}
                    valuesAllocatedPeriod={valuesAllocatedPeriod}
                    AuthorizationSources={valuesAuthorizationSources}
                    orderCaseTypeValues={orderCaseTypeValues}
                    orderReferralSourceValues={orderReferralSourceValues}
                    studentsValues={props.students}
                    serviceTypesOrderValues={serviceTypesOrderValues}
                    ServiceTypeProviders={ServiceTypeProviders}
                    files={files}
                    setFiles={setFiles}
                    removeFile={(id) => {
                        files.splice(id, 1);
                        setFiles([...files]);
                    }}
                    initialValues={{
                        orderTypeDropDown: props.orderTypes[0],
                        orderSubtypeDropDown: valuesOrderSubtype[0],
                        authorizationSourceDropDown: valuesAuthorizationSources[0],

                        //    ...initVal,
                    }}
                />
            </div>
        </RoleLayout>
    );
};

export default OrderCreateScreen;
